import Browser from '../core/browser'
import { EventBus } from '../core/smpl-components'

const BREAKPOINTS = {
	XSMALL: 0,
	SMALL: 576,
	MEDIUM: 768,
	LARGE: 992,
	XLARGE: 1280,
	XXLARGE: 1536,
	XXCLARGE: 1920,
}

export const initGlobals = () => {
	const context = {
		breakpoints: BREAKPOINTS,
		browser: new Browser(),
		eventBus: EventBus,
	}

	// The single global handle on the app context. Exposed once here (e.g. for
	// console debugging and a few cross-cutting reads in core/). Internal code
	// should receive `ctx` explicitly rather than reaching for window.app.
	window.app = context

	return context
}
